import { render, staticRenderFns } from "./RequisitionPDFFooter.vue?vue&type=template&id=2870d442&scoped=true&"
import script from "./RequisitionPDFFooter.vue?vue&type=script&lang=js&"
export * from "./RequisitionPDFFooter.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionPDFFooter.vue?vue&type=style&index=0&id=2870d442&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870d442",
  null
  
)

export default component.exports